import HomeOne from "./HomeOne";
import About from "./About";
import Blog from "./Blog";
import BlogDetails from "./BlogDetails";
import Contact from "./Contact";
import Faq from "./Faq";
import Help from "./Help";
import Work from "./Work";
import Error from "./Error";
import Pricing from "./Pricing";
import CommunityGuidelines from "./CommunityGuidelines";
import DataResidency from "./DataResidency";
import OurCharter from "./OurCharter";
import Security from "./Security";
import Terms from "./Terms";
import PrivacyPolicy from "./PrivacyPolicy";
import SafetyOverview from "./SafetyOverview";
import DataRemovalPolicy from "./DataRemovalPolicy";

const routes = [
  { path: '/', component: <HomeOne />},
  { path: '/about', component: <About />},
  { path: '/blog', component: <Blog />},
  { path: '/blog/:slug', component: <BlogDetails />},
  { path: '/faq', component: <Faq />},
  { path: '/help', component: <Help />},
  { path: '/work', component: <Work />},
  { path: '/contact', component: <Contact />},
  { path: '/pricing', component: <Pricing />},
  { path: '/community-guidelines', component: <CommunityGuidelines />},
  { path: '/data-residency', component: <DataResidency />},
  { path: '/charter', component: <OurCharter />},
  { path: '/security', component: <Security />},
  { path: '/terms', component: <Terms />},
  { path: '/privacy-policy', component: <PrivacyPolicy />},
  { path: '/safety-overview', component: <SafetyOverview />},
  { path: '/data-removal-policy', component: <DataRemovalPolicy />},
  { path: '*', component: <Error />}
]

export default routes;